import { Link } from 'react-router';

import ForgotPasswordForm from '@/components/forms/forgot-password-form';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const ForgotPasswordPage = () => {
  return (
    <Card className="w-[500px]">
      <CardHeader>
        <CardTitle>비밀번호 찾기</CardTitle>
      </CardHeader>
      <CardContent>
        <ForgotPasswordForm />
      </CardContent>
      <div className="w-full flex justify-center items-center">
        <Button variant="link">
          <Link to="/sign-in">로그인하기</Link>
        </Button>

        <Button variant="link">
          <Link to="/sign-up">회원가입하기</Link>
        </Button>
      </div>
    </Card>
  );
};

export default ForgotPasswordPage;
